import { GLOBAL_TIMEOUT } from '@/settings.js';

const INITIAL_STATE = {
  isDisabled: false,
  timerId: null,
};

// дизейблим все кнопки действий с нажатия до получения ответа от сервера
const disableButton = {
  data() {
    return {
      buttonState: {},
    };
  },
  methods: {
    disableButton(buttonId) {
      if (!Object.prototype.hasOwnProperty.call(this.buttonState, buttonId)) {
        this.buttonState = {
          ...this.buttonState,
          [buttonId]: INITIAL_STATE,
        };
      }
      this.buttonState[buttonId].isDisabled = true;
      this.buttonState[buttonId].timerId = setTimeout(() => {
        this.buttonState[buttonId].isDisabled = false;
      }, GLOBAL_TIMEOUT);
    },
    enableButton(buttonId) {
      if (this.buttonState[buttonId].timerId !== null) {
        clearTimeout(this.buttonState[buttonId].timerId);
      }
      this.buttonState[buttonId].isDisabled = false;
    },
    isButtonDisabled(buttonId) {
      return Object.prototype.hasOwnProperty.call(this.buttonState, buttonId)
        ? this.buttonState[buttonId].isDisabled
        : false;
    },
  },
};

export { disableButton };
